'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _reactUtils = require('react-utils');

var _utils = require('./utils');

var _Functions = require('../core/Functions');

var _SyntheticEvent = require('../core/SyntheticEvent');

var _SyntheticEvent2 = _interopRequireDefault(_SyntheticEvent);

var _decorators = require('../utils/propTypes/decorators');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Activeable = (0, _utils.eventHandlerDecoratorFactory)({
  displayNameFunc: function displayNameFunc(Component) {
    return 'Activeable(' + (0, _reactUtils.getComponentName)(Component) + ')';
  },
  propTypes: {
    className: _react.PropTypes.string,
    active: (0, _decorators.hidden)(_react.PropTypes.bool),
    onActiveChange: (0, _decorators.hidden)(_react.PropTypes.func)
  },
  defaultProps: {
    active: undefined
  },
  initialState: {
    active: false
  },
  eventHandlers: {
    onMouseDown: function onMouseDown() {
      var _this = this;

      this.setState({ active: true });
      (0, _Functions.callIfPossible)(this.props.onActiveChange, (0, _SyntheticEvent2.default)(true));
      var onWindowMouseUp = function onWindowMouseUp() {
        _this.setState({ active: false });
        (0, _Functions.callIfPossible)(_this.props.onActiveChange, (0, _SyntheticEvent2.default)(false));
        window.removeEventListener('mouseup', onWindowMouseUp);
      };
      window.addEventListener('mouseup', onWindowMouseUp);
    },
    onKeyDown: function onKeyDown(evt) {
      var key = evt.key;

      if (key !== 'Enter' && key !== ' ') return;
      this.setState({ active: true });
      (0, _Functions.callIfPossible)(this.props.onActiveChange, (0, _SyntheticEvent2.default)(true));
    },
    onKeyUp: function onKeyUp(evt) {
      var key = evt.key;

      if (key !== 'Enter' && key !== ' ') return;
      this.setState({ active: false });
      (0, _Functions.callIfPossible)(this.props.onActiveChange, (0, _SyntheticEvent2.default)(false));
    }
  },
  getPropsForRender: function getPropsForRender(props, state) {
    // Set active={undefined} when state.active === false to avoid affecting ARIA attrs in UIButton.
    var activeState = state.active || undefined;

    var active = props.active != null ? props.active : activeState;
    return _extends({}, props, {
      active: active
    });
  }
});

exports.default = Activeable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/decorators/Activeable.js
// module id = 262
// module chunks = 0